import { render } from "./DPlayer.vue?vue&type=template&id=004bfd7a"
import script from "./DPlayer.vue?vue&type=script&lang=ts"
export * from "./DPlayer.vue?vue&type=script&lang=ts"
script.render = render

export default script